import React from "react";
import {
  blackShade19,
  border25,
  greyColor7,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { Box, Grid, Typography } from "@mui/material";
import InputPreview from "../../../components/Input/InputPreview";

function ProductDetailPreview({ productInfo }) {
  return (
    <Box sx={styles.card}>
      <Typography sx={styles.title}>Product Detail</Typography>
      <Grid container rowSpacing={{ xs: 2, md: 2 }} columnSpacing={3}>
        <Grid item xs={12} md={3}>
          <InputPreview label="Brand" value={productInfo?.brand} hideBorder />
        </Grid>

        <Grid item xs={12} md={3}>
          <InputPreview
            label="Country of Origin"
            value={productInfo?.country?.name}
            hideBorder
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <InputPreview
            label="Product Description"
            value={productInfo?.description}
            hideBorder
            isReadMoreLess
          />
        </Grid>
      </Grid>
      <Box pt={1.2} mb={0}>
        <Typography sx={styles.title}>Tax and GST Information</Typography>
      </Box>

      <Grid container rowSpacing={{ xs: 2, md: 0 }} columnSpacing={3}>
        <Grid item xs={6} md={3}>
          <InputPreview label="Taxes Included" value={"Yes"} hideBorder />
        </Grid>

        <Grid item xs={6} md={3}>
          <InputPreview
            label="GST Percentage(%)"
            value={productInfo?.gstPercentage}
            hideBorder
          />
        </Grid>
      </Grid>

      <Box pt={1.2} mb={0}>
        <Typography sx={styles.title}>Reference Link</Typography>
      </Box>

      {productInfo?.refLinks?.length === 1 &&
      !productInfo?.refLinks?.[0]?.code &&
      !productInfo?.refLinks?.[0]?.link ? (
        <Typography
          component="h6"
          fontSize={13.5}
          color={greyColor7}
          fontWeight={500}
          lineHeight="20px"
          m="10px 0 15px !important"
        >
          N/A
        </Typography>
      ) : (
        <>
          {productInfo?.refLinks?.map((item, index) => {
            return (
              <Box key={`ref_link_${index}`} mb={{ xs: 2, md: 2 }}>
                <Grid container rowSpacing={{ xs: 2, md: 2 }} columnSpacing={3}>
                  <Grid item xs={12} md={3.5}>
                    <InputPreview
                      label="Link Name"
                      value={item?.code}
                      hideBorder
                    />
                  </Grid>

                  <Grid item xs={12} md={8.5}>
                    <InputPreview label="Link" value={item?.link} hideBorder />
                  </Grid>
                </Grid>
              </Box>
            );
          })}
        </>
      )}
    </Box>
  );
}

export default ProductDetailPreview;

const styles = {
  card: {
    backgroundColor: whiteColor,
    borderRadius: "13px",
    border: border25,
    boxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
    p: "15px 15px 15px",
    mb: 2,
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    mb: "10px",
    color: blackShade19,
  },
};
